import React, {useEffect, useState} from 'react'
import {DateInput} from '../../../../common/date-picker/date-input'
import {customFormatDate} from '../../../../crm-activities-view/custom-format-date'

interface Props {
  date: number
  setDate: (date: number) => void
  icon?: boolean
  color: string
}

export const DealTimeDatePicker = (props: Props) => {
  const {date, setDate, icon, color} = props
  const [localValue, setLocalValue] = useState(date)

  useEffect(() => {
    setLocalValue(date)
  }, [date])

  return (
    <DateInput
      placement="top"
      hideArrow={false}
      initialDate={new Date(localValue)}
      onlyText={true}
      showTimeInput={true}
      textClassName={color}
      iconClassName={color}
      icon={icon ? 'IconCustomCalendarEvent' : undefined}
      onChoose={date => {
        setDate(date.getTime())
        setLocalValue(date.getTime())
      }}
      customFormatDate={customFormatDate}
    />
  )
}
